import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileTimesheetNew } from '@/features/timesheet/mobile/MobileTimesheetNew';

export const Route = createFileRoute('/_app/timesheet/new')({
  validateSearch: (s: Record<string, unknown>): { date?: string } => ({
    date: typeof s.date === 'string' ? s.date : undefined,
  }),
  component: TimesheetNewPage,
});

/** Form "Nuova attività" di rendicontazione (solo mobile). */
function TimesheetNewPage() {
  const isMobile = useIsMobileShell();
  const { date } = Route.useSearch();
  return isMobile ? <MobileTimesheetNew date={date} /> : <Navigate to="/timesheet" />;
}
